<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/app-popup/table">APP浮窗配置列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="标题："
                          prop="title">
              <el-input :disabled="isDetailMode" v-model="form.title"></el-input>
            </el-form-item>
          </div>
          <div class="medium">
            <el-form-item label="封面图片："
                          prop="img_url">
              <el-upload
                :disabled="isDetailMode"
                ref="upload"
                class="avatar-uploader"
                :auto-upload="false"
                action=""
                :show-file-list="false"
                :on-change="onChangeFile"
                :on-remove="handleRemove">
                <img v-if="form.img_url" :src="form.img_url" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="upload-tip">建议尺寸：250px*250px</div>
            </el-form-item>
          </div>
          <div class="medium">
            <el-form-item label="小浮窗事件："
                          prop="target_type">
              <el-select :disabled="isDetailMode" v-model="form.target_type" placeholder="请选择小浮窗事件" @change="onChangeTargetType">
                <el-option v-for="item in targetTypes"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="medium">
            <el-form-item label="落地页路径："
                          prop="target_url">
              <el-input :disabled="isDetailMode || disableTargetUrl" v-model="form.target_url"></el-input>
            </el-form-item>
          </div>
          <div class="medium">
            <el-form-item label="上下线时间："
                          prop="launch_time_range">
              <el-date-picker
                :disabled="isDetailMode"
                v-model="form.launch_time_range"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                :picker-options="pickerOptions"
                clearable>
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="medium">
            <el-form-item label="展示对象："
                          prop="user_currentstatus">

              <el-checkbox-group v-model="form.user_currentstatus">
                <el-checkbox :disabled="isDetailMode || disableUserCurrentStatus" v-for="item in userOptions.currentstatus"
                             :key="item.value"
                             :label="item.value"
                >
                  {{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button :disabled="isDetailMode" type="primary"
                     native-type="submit">提交
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../app-popup.rules.js'

export default {
  data () {
    return {
      id: 0,
      isDetailMode: false,
      formRules,
      form: {
        title: '',
        img_url: '',
        target_type: '',
        target_url: '',
        launch_time_range: [],
        user_currentstatus: [],
      },
      targetTypes: [
        { value: 1, label: '打开网页' },
        { value: 2, label: '打开智能客服' },
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7 // 禁止选择今天之前的时间
        },
      },
      imgFileList: [],
      disableTargetUrl: false,
      disableUserCurrentStatus: false,
    }
  },
  computed: Vuex.mapState({
    userOptions: state => state.users.options,
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {
    this.isDetailMode = this.$route.path.includes('detail')
  },
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getAppPopupDetail', {id}).then(({data}) => {
        data.launch_time_range = [
          data.launch_time,
          data.end_time,
        ]
        data.target_type = Number(data.target_type)
        // 选择智能客服，禁止选择落地页路径和展示对象
        if (data.target_type === 2) {
          this.disableTargetUrl = true
          this.disableUserCurrentStatus = true
        }
        filter.setLoop(this.form, data)
        this.imgFileList = [{
          url: data.img_url,
        }]
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    onSubmit () {
      if (this.isDetailMode) return // 如果是详情模式，阻止提交
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createAppPopupData', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/app-popup/table/'})
        })
      })
    },
    update (id) {
      request.common('updateAppPopupData', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/app-popup/table/'})
        })
      })
    },
    handleRemove (valName) {
      this.form.img = ''
    },
    onChangeTargetType (newVal) {
      if (newVal === 2) {
        this.form.target_url = 'customer_service'
        this.disableTargetUrl = true
        this.form.user_currentstatus = [0, 4]
        this.disableUserCurrentStatus = true
      } else {
        this.form.target_url = ''
        this.disableTargetUrl = false
        this.form.user_currentstatus = []
        this.disableUserCurrentStatus = false
      }
    },
    onChangeFile (file, fileList) {
      let isExcel = ((file.raw.type === 'image/jpeg') || (file.raw.type === 'image/png'))
      let isLt2M = file.raw.size / 1024 / 1024 < 2

      // 图片尺寸验证
      const checkImageDimensions = (file) => {
        return new Promise((resolve) => {
          const img = new Image()
          img.src = URL.createObjectURL(file)
          img.onload = () => {
            const width = img.width
            const height = img.height
            const isValid = width <= 250 && height <= 250
            resolve(isValid)
          }
        })
      }

      if (!isExcel) {
        this.$message.error('请上传jpg/jpeg/png图片!')
        this.$refs.upload.clearFiles()
        return false
      }
      if (!isLt2M) {
        this.$message.error('大小不能超过2MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      // 新增尺寸验证
      checkImageDimensions(file.raw).then(isValid => {
        if (!isValid) {
          this.$message.error('图片尺寸不能超过250x250像素!')
          this.$refs.upload.clearFiles()
          return false
        }
        this.onUploadFile(file.raw)
      })
    },
    onUploadFile (file) {
      let formData = new FormData()
      formData.append('file', file)
      return request.common('uploadImgFile', formData).then(({data}) => {
        this.form.img_url = data
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
.re-el-form__flex {
  display: inline;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}
.upload-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #999;
}
</style>




// WEBPACK FOOTER //
// src/views/app-popup/pages/AppPopupForm.vue